
export default {
  id: 'UA-150593779-6',
}
